import React from 'react'
import MasonryDescriptionContainer from '../../../../Components/Miscellaneous/Gallery/MasonryDescription'

export default function MasonryGalleryDescription() {
  return (
    <div className='page-body'>
        <MasonryDescriptionContainer/>
    </div>
  )
}
